import apiService from './api.service';

const getCalculatorDashboardContent = () => apiService.authRequest('content/calculator');

export default {
  getCalculatorDashboardContent,
};
